export const SHARE_LINK_ACCESS_TYPES = {
    password: 'People with password',
};

export const SHARE_TYPES = {
    project: 'project',
    file: 'file',
} as const;
